import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './HYBRID_Combined_Distribution_Waterfall.css';

const HYBRID_Combined_Distribution_Waterfall = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	HYBRID_COMBINED_DISTRIBUTION_WATERFALL:-1
  });


  const [HYBRID_COMBINED_DISTRIBUTION_WATERFALL, setHYBRID_COMBINED_DISTRIBUTION_WATERFALL] = React.useState(null);
  const [HYBRID_COMBINED_DISTRIBUTION_WATERFALL_D, setHYBRID_COMBINED_DISTRIBUTION_WATERFALL_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Hybrid Combined Distribution Waterfall');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/HYBRID_Combined_Distribution_Waterfall',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewHYBRID_COMBINED_DISTRIBUTION_WATERFALL(clientInfo,"OpenNew");

		navigate('/HYBRID_Combined_Distribution_Waterfall',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Combined_Distribution_Waterfall_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewHYBRID_COMBINED_DISTRIBUTION_WATERFALL(clientInfo,"OpenNew");
		}
		navigate('/HYBRID_Combined_Distribution_Waterfall',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Combined_Distribution_Waterfall_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Combined_Distribution_Waterfall_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Combined_Distribution_Waterfall_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
		if(Temp_Data2.status!="New"){
			handleDeleteHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data2);
			navigate('/HYBRID_Combined_Distribution_Waterfall#New',{replace:true});
		} 
		else 
			navigate('/HYBRID_Combined_Distribution_Waterfall',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Combined_Distribution_Waterfall',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Combined_Distribution_Waterfall',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Combined_Distribution_Waterfall',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Combined_Distribution_Waterfall',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!HYBRID_COMBINED_DISTRIBUTION_WATERFALL) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_${i}_SECTION`;
	  const headerId = `#HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');
    if ($('#Table3').length > 0) window.DataTableScript('#Table3');

    initRef.current.dataTableHandled = true;
  }  

  }, [HYBRID_COMBINED_DISTRIBUTION_WATERFALL]) ;


  
  
  var Ids = [];
  for(var Ele in HYBRID_COMBINED_DISTRIBUTION_WATERFALL){
	  for(var Sec in HYBRID_COMBINED_DISTRIBUTION_WATERFALL[Ele]){
		if(Sec == "id")
			Ids.push(HYBRID_COMBINED_DISTRIBUTION_WATERFALL[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(HYBRID_COMBINED_DISTRIBUTION_WATERFALL[Ele]["status"]);
		else if(Array.isArray(HYBRID_COMBINED_DISTRIBUTION_WATERFALL[Ele][Sec]))
			  for(var Row in HYBRID_COMBINED_DISTRIBUTION_WATERFALL[Ele][Sec])  // Convert to HYBRID_COMBINED_DISTRIBUTION_WATERFALL[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in HYBRID_COMBINED_DISTRIBUTION_WATERFALL[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["HYBRID_COMBINED_DISTRIBUTION_WATERFALL"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewHYBRID_COMBINED_DISTRIBUTION_WATERFALL(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMBINED_DISTRIBUTION_WATERFALL`).then((response1) => {
		if(!HYBRID_COMBINED_DISTRIBUTION_WATERFALL) 
			setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMBINED_DISTRIBUTION_WATERFALL_D`).then((response2) => {
			setHYBRID_COMBINED_DISTRIBUTION_WATERFALL_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewHYBRID_COMBINED_DISTRIBUTION_WATERFALL = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMBINED_DISTRIBUTION_WATERFALL/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMBINED_DISTRIBUTION_WATERFALL/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutHYBRID_COMBINED_DISTRIBUTION_WATERFALL = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMBINED_DISTRIBUTION_WATERFALL/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostHYBRID_COMBINED_DISTRIBUTION_WATERFALL = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMBINED_DISTRIBUTION_WATERFALL', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteHYBRID_COMBINED_DISTRIBUTION_WATERFALL = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_COMBINED_DISTRIBUTION_WATERFALL', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["1"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_0"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("1","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_0",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  
    
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["1"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_1"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("1","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_1",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  

const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["4"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_0"]=value;
	Form_Data_onChange("4","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_0",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
  }; 
  

    
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["4"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_1"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("4","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_1",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  
    
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["5"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_0"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("5","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_0",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  
    
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["5"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_1"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("5","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_1",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  
    
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["5"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_2"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("5","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_2",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  
    
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["5"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_3"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("5","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_3",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  

const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["5"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_4"]=value;
	Form_Data_onChange("5","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_4",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
  }; 
  

    
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["5"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_5"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("5","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_5",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  

const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["9"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_0"]=value;
	Form_Data_onChange("9","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_0",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
  }; 
  

    
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["9"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_1"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("9","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_1",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  
    
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["9"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_2"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("9","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_2",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  
    
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["9"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_3"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("9","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_3",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  
    
const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["9"]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_4"]=value;
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
	Form_Data_onChange("9","HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_4",value,Temp_Data);
 	//handleLastDataHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
 }; 
  

const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));  
  Temp_Data['2'][index]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_0"] = value;
  setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
};


const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["2"][index]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_1"]=value;
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
  }; 
  

const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["2"][index]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_2"]=value;
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
  }; 
  

const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["2"][index]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_3"]=value;
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
  }; 
  

const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["2"][index]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_4"]=value;
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
  }; 
  


const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));  
  Temp_Data['3'][index]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_0"] = value;
  setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
};


const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["3"][index]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_1"]=value;
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
  }; 
  

const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["3"][index]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_2"]=value;
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
  }; 
  

const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["3"][index]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_3"]=value;
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
  }; 
  

const HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
	Temp_Data["3"][index]["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_4"]=value;
    setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data);
	//handleAddHYBRID_COMBINED_DISTRIBUTION_WATERFALL(Temp_Data,App_Data['HYBRID_COMBINED_DISTRIBUTION_WATERFALL']);
  }; 
  



 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!HYBRID_COMBINED_DISTRIBUTION_WATERFALL) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_0']='';
	    newRow['HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_1']='';
	    newRow['HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_2']='';
	    newRow['HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_3']='';
	    newRow['HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_4']='';
	    break;
	  case('3'):
	    newRow['HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_0']='';
	    newRow['HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_1']='';
	    newRow['HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_2']='';
	    newRow['HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_3']='';
	    newRow['HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_4']='';
	    break;

  }


  const updatedHYBRID_COMBINED_DISTRIBUTION_WATERFALL =JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
  updatedHYBRID_COMBINED_DISTRIBUTION_WATERFALL[Sec] = [...updatedHYBRID_COMBINED_DISTRIBUTION_WATERFALL[Sec], newRow];
  setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(updatedHYBRID_COMBINED_DISTRIBUTION_WATERFALL);
};

const handleDeleteRow = (sec,index) => {
  const updatedHYBRID_COMBINED_DISTRIBUTION_WATERFALL = JSON.parse(JSON.stringify(HYBRID_COMBINED_DISTRIBUTION_WATERFALL));
  updatedHYBRID_COMBINED_DISTRIBUTION_WATERFALL[sec].splice(index, 1);
  setHYBRID_COMBINED_DISTRIBUTION_WATERFALL(updatedHYBRID_COMBINED_DISTRIBUTION_WATERFALL);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Hybrid Combined Distribution Waterfall`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Hybrid Waterfall ID`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`HYBRID Waterfall ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_0" type="text" className="form-control" placeholder="HYBRID Waterfall ID" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["1"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_0`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter HYBRID Waterfall ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_1" type="text" className="form-control" placeholder="Offering ID" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["1"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_1`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_HEADER">{t(`Distribution Component Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Distribution Component Type`)}</th>
                        <th>{t(`Rental Income Amount USD`)}</th>
                        <th>{t(`Revenue Share Amount USD`)}</th>
                        <th>{t(`Sale Profit Amount USD`)}</th>
                        <th>{t(`Equity Appreciation Amount USD`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {HYBRID_COMBINED_DISTRIBUTION_WATERFALL['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_0`]} data-search={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_0"  onChange={(ev) => HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_0_Change(ev, i)}  className="form-control" value={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_0`]} name="Distribution Component Type">
						  <option value="Gross Source Amount">Gross Source Amount</option>
						  <option value="Operating Expense">Operating Expense</option>
						  <option value="Reserve">Reserve</option>
						  <option value="Debt Service">Debt Service</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Net Distribution">Net Distribution</option>
						  <option value="Investor Distribution">Investor Distribution</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_1`]} data-search={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_1" type="text" onChange={(ev) => HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_1_Change(ev, i)} className="form-control" value={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_1`]} placeholder="Rental Income Amount USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_2`]} data-search={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_2" type="text" onChange={(ev) => HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_2_Change(ev, i)} className="form-control" value={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_2`]} placeholder="Revenue Share Amount USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_3`]} data-search={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_3" type="text" onChange={(ev) => HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_3_Change(ev, i)} className="form-control" value={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_3`]} placeholder="Sale Profit Amount USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_4`]} data-search={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_4" type="text" onChange={(ev) => HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_4_Change(ev, i)} className="form-control" value={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_2_4`]} placeholder="Equity Appreciation Amount USD"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_HEADER">{t(`Distribution Component Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('3')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table3" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Distribution Component Type`)}</th>
                        <th>{t(`Debt Interest Amount USD`)}</th>
                        <th>{t(`Preferred Return Amount USD`)}</th>
                        <th>{t(`Common Equity Amount USD`)}</th>
                        <th>{t(`Total Distributable Amount USD`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {HYBRID_COMBINED_DISTRIBUTION_WATERFALL['3'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_0`]} data-search={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_0"  onChange={(ev) => HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_0_Change(ev, i)}  className="form-control" value={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_0`]} name="Distribution Component Type">
						  <option value="Gross Source Amount">Gross Source Amount</option>
						  <option value="Operating Expense">Operating Expense</option>
						  <option value="Reserve">Reserve</option>
						  <option value="Debt Service">Debt Service</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Net Distribution">Net Distribution</option>
						  <option value="Investor Distribution">Investor Distribution</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_1`]} data-search={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_1" type="text" onChange={(ev) => HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_1_Change(ev, i)} className="form-control" value={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_1`]} placeholder="Debt Interest Amount USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_2`]} data-search={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_2" type="text" onChange={(ev) => HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_2_Change(ev, i)} className="form-control" value={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_2`]} placeholder="Preferred Return Amount USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_3`]} data-search={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_3" type="text" onChange={(ev) => HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_3_Change(ev, i)} className="form-control" value={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_3`]} placeholder="Common Equity Amount USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_4`]} data-search={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_4" type="text" onChange={(ev) => HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_4_Change(ev, i)} className="form-control" value={e[`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_3_4`]} placeholder="Total Distributable Amount USD"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Waterfall Priority`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Waterfall Priority`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_0"  value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["4"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_0`]} onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_0_Change} className="form-control" name="Waterfall Priority"  >
						  <option value="Debt First">Debt First</option>
						  <option value="Preferred Return First">Preferred Return First</option>
						  <option value="Pro Rata">Pro Rata</option>
						  <option value="Manager Promote After Hurdle">Manager Promote After Hurdle</option>
						  <option value="Custom">Custom</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Waterfall Priority
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Waterfall Report Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_1" type="text" className="form-control" placeholder="Waterfall Report Link" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["4"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_1`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Waterfall Report Link`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_0" type="text" className="form-control" placeholder="Submitted By" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["5"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_0`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_1" type="text" className="form-control" placeholder="Submitted At" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["5"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_1`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_2" type="text" className="form-control" placeholder="Reviewed By" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["5"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_2`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_3" type="text" className="form-control" placeholder="Reviewed At" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["5"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_3`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_4"  value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["5"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_4`]} onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_5" type="text" className="form-control" placeholder="Approval Notes" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["5"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_5`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_0"  value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["9"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_0`]} onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_1" type="text" className="form-control" placeholder="Created By" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["9"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_1`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_2" type="text" className="form-control" placeholder="Created At" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["9"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_2`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_3" type="text" className="form-control" placeholder="Updated By" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["9"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_3`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_4" type="text" className="form-control" placeholder="Updated At" value={HYBRID_COMBINED_DISTRIBUTION_WATERFALL["9"][`HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_4`]} 
						onChange={HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_05_FINANCE_WATERFALL_DISTRIBUTION_REPORTING_HYBRID_COMBINED_DISTRIBUTION_WATERFALL_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default HYBRID_Combined_Distribution_Waterfall;  